export default __webpack_public_path__ + "static/media/ShantyTown.4429a872.jpg";